import { get } from "./api";

export const GET_ISOCOUNTRIES_SUCCESS = `GET_ISOCOUNTRIES_SUCCESS`;
export const GET_ISOCOUNTRIES_ERROR = `GET_ISOCOUNTRIES_ERROR`;

function transformAPIResponseToReducerIsoCountries(res) {
  var x = res.reduce((acc, curr) => {
    acc.push({
      id: curr.id,
      nameL10n: curr.nameL10n,
      isoCountryAlpha2: curr.alpha2Code,
      isoCountryAlpha3: curr.alpha3Code,
      isEuMemberState: curr.isEuMemberState
    });

    return acc;
  }, []);

  return x;

};

const initialState = {
  isoCountries: [  ]
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ISOCOUNTRIES_SUCCESS:
      return { isoCountries: [...state.isoCountries, ...transformAPIResponseToReducerIsoCountries(payload)] };

    default:
      return state;
  }
};

export const saveIsoCountries = (payload) => ({
  type: GET_ISOCOUNTRIES_SUCCESS,
  payload
});

export const fetchIsoCountries = () => async (dispatch) => {
  try {
    const { data } = await dispatch(get(`/isoCountries`));

    dispatch(saveIsoCountries(data));
  } catch (error) {
    // TODO:Handle error
  }
};